import Signup from "../components/signup/Signup";

export default function SignupPage() {
  return <Signup />;
}
